import { config } from '@/config'
/**
 * @description
 * Helpリンク用URL管理用ファイル
 * コメントを参考に追加していってください
 *
 * - getHelpUrl: ヘルプURL取得関数
 * - intercomArticleParamMap: intercom articlesのマップ
 * - helpUrlMap: 全てのヘルプURLのマップ
 */

/**
 * @description
 * ヘルプURL取得関数
 * @param key ヘルプURLのキー
 */
const getHelpUrl = (key: keyof typeof helpUrlMap) => {
  return helpUrlMap[key]
}

const intercomArticleBaseUrl = 'https://help.utoniq.com/ja/articles/'
const getIntercomArticleUrl = (articleParam: number | string) =>
  `${intercomArticleBaseUrl}${articleParam}`
/**
 * @description
 * intercom helpページのパラメーターMap
 * articleを追加した際は以下に キー:記事ID で追加してください。
 * https://app.intercom.com/a/apps/ofcvelff/articles/articles/list/all
 */
const intercomArticleParamMap = {
  item: 6174903,
  serialNumber: 5916146,
  audioItem: '6681730#h_f3e810a6bd',
  videoItem: '6681730#h_bc1df8d50a',
  magazineItem: '6681730#h_0b7814f193',
  wallpaperItem: '6681730#h_4ef1149295',
  avatarItem: '6681730#h_d55aaf5425',
  merchItem: '6681730#h_1d76277b1a',
  thread: 6308816,
  liveStream: 6308816,
  howToIssueNft: 6367004,
  ownedItemDetail: 6174903,
  createCryptoWallet: 6739506,
  ranking: 6972549,
  resaleExhibit: 8061242,
  resaleApply: 8061252,
  resalePayment: '8061252#h_deb4ff030f',
  preSale: '8965589',
  ticketDistribution: '9758683-チケットの分配機能について',
  collection: '9586892-コレクションについて',
} as const
type IntercomArticleKeys = keyof typeof intercomArticleParamMap

/**
 * @description
 * ヘルプURLのマップ
 *  - intercomのarticleの場合： intercomArticleParamMapに追加
 *  - intercom以外の場合： helpUrlMapsに直接追加
 *  - アプリ毎に動的なヘルプURLの場合： アプリ毎のconfigで管理し、helpUrlMapに追加
 */
const helpUrlMap = {
  ...(Object.fromEntries(
    Object.entries(intercomArticleParamMap).map(([key, param]) => [
      key,
      getIntercomArticleUrl(param),
    ])
  ) as { [key in IntercomArticleKeys]: string }),
  /**
   * アプリ毎個別のヘルプURL
   * - intercomのcollectionsに作成する。アプリ毎に動的なためconfigにてURLを管理する
   * - https://app.intercom.com/a/apps/ofcvelff/articles/site/collections
   */
  appHelp: config.helpUrl,
  /**
   * 特定商取引法に基づく表記の表示URL
   */
  specifiedCommercialTransactionLaw: 'https://about.utoniq.com/tokushoho',
  /**
   * 資金決済法に基づく表示URL
   * - 現在、DiicaとSDPのみ資金決済法の表示を出し分けているため以下表示リンクを分けている
   */
  wageSettlementMethod:
    config.applicationKey === 'diica'
      ? 'https://about.utoniq.com/diica_financial_agreement'
      : config.applicationKey === 'sdp'
      ? 'https://about.utoniq.com/digitalsdp_financial_agreement'
      : 'https://about.utoniq.com/financial_agreement',
} as const

export { getHelpUrl }
